import React, { useEffect, useState } from 'react';
import apiService from '../../../apiService/Subscription/api-service';

const SubscriptionMetric = ({dateValue, filtersdata}) => {
    const [contentLoader, setContentLoader] = useState(false);

    const [reportData, setReportData] = useState({});

    // Function to check if date range is within 3 months
    const isWithinThreeMonths = (fromDateStr, toDateStr) => {
        const fromDate = new Date(fromDateStr);
        const toDate = new Date(toDateStr);
        const maxToDate = new Date(fromDate);
        maxToDate.setMonth(maxToDate.getMonth() + 3);
        return toDate <= maxToDate;
    }

    useEffect(() => {
      fetchMetricData();
    }, []);


    async function fetchMetricData() {
        const startDate = dateValue?.startDate;
        const endDate = dateValue?.endDate;

        if (!startDate || !endDate) {
            return;
        }

        if (!isWithinThreeMonths(startDate, endDate)) {
           return alert("Date range exceeds 3 months")
        }

        if(contentLoader) return;

        setContentLoader(true);

        try {
            const response = await apiService.fetchMetrics({
                start_date: startDate,
                end_date: endDate,
                product_id: filtersdata?.productFilter || '',
                plan: filtersdata?.planFilter || '',
                platform: filtersdata?.platformFilter || ''
            });

            if (response?.data?.success) {
                const data = response.data?.data?.reportData || {};
                setReportData(data);
            } else {
                setReportData({});
            }
        } catch (error) {
            console.error('Error fetching subscription metrics:', error);
            setReportData({});
        } finally {
            setContentLoader(false);
        }
    }   

    useEffect(() => {
        fetchMetricData();
    },[filtersdata, dateValue])

    return (
        <>
        {/* Show loading state or metrics cards exclusively */}
        {contentLoader ? (
          <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 mb-4">
            <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-green-500">
                <div className="flex items-center justify-between">
                    <div>
                        <h3 className="text-xs font-medium text-gray-500 mb-1">Loading</h3>
                    </div>
                </div>
            </div>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-green-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">Active Subscribers</h3>
                            <p className="text-xl font-bold text-gray-900">{reportData?.aquiredCount ? Number(reportData?.aquiredCount).toLocaleString('en-IN') : '0'}</p>
                            {/* <p className="text-xs text-green-600 mt-1">↑ 12% from last month</p> */}
                            <p className="text-xs text-green-600 mt-1">Selected Period</p>
                        </div>
                    </div>
                </div>
            
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-yellow-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">Total INR Revenue</h3>
                            <p className="text-xl font-bold text-gray-900">₹{reportData && reportData.inrRevenue ? Number(reportData?.inrRevenue)?.toLocaleString('en-IN') : 0}</p>
                            {/* <p className="text-xs text-green-600 mt-1"></p> */}
                            <p className="text-xs text-yellow-600 mt-1">Net Revenue: ₹{reportData && reportData.inrNetRevenue ? Number(reportData?.inrNetRevenue)?.toLocaleString('en-IN') : 0}</p>
                        </div>
                    </div>
                </div>
            
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-purple-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">Total USD Revenue</h3>
                            <p className="text-xl font-bold text-gray-900">${reportData && reportData.usdRevenue ? Number(reportData?.usdRevenue)?.toLocaleString('en-US') : 0}</p>
                            <p className="text-xs text-purple-600 mt-1">Net Revenue: ₹{reportData && reportData.usdNetRevenue ? Number(reportData?.usdNetRevenue)?.toLocaleString('en-IN') : 0}</p>
                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-indigo-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">Total Revenue</h3>
                            <p className="text-xl font-bold text-gray-900">₹{reportData && reportData.totalRevenue ? Number(reportData?.totalRevenue)?.toLocaleString('en-US') : 0}</p>
                            <p className="text-xs text-indigo-600 mt-1">Net Revenue: ₹{reportData && reportData.totalNetRevenue ? Number(reportData?.totalNetRevenue)?.toLocaleString('en-IN') : 0}</p>
                        </div>
                    </div>
                </div>
            </div>



            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-green-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">FY - {reportData?.fyStartYear}/{reportData?.fyEndYear} Active Subscribers</h3>
                            <p className="text-xl font-bold text-gray-900">{reportData?.fyAquired ? Number(reportData?.fyAquired).toLocaleString('en-IN') : '0'}</p>
                            {/* <p className="text-xs text-green-600 mt-1">↑ 12% from last month</p> */}
                            <p className="text-xs text-green-600 mt-1">Financial Year</p>
                        </div>
                    </div>
                </div>
            
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-yellow-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">FY - {reportData?.fyStartYear}/{reportData?.fyEndYear} Total INR Revenue</h3>
                            <p className="text-xl font-bold text-gray-900">₹{reportData && reportData.fyInrRevenue ? Number(reportData?.fyInrRevenue)?.toLocaleString('en-IN') : 0}</p>
                            {/* <p className="text-xs text-green-600 mt-1"></p> */}
                            <p className="text-xs text-yellow-600 mt-1">Net Revenue: ₹{reportData && reportData.fyInrNetRevenue ? Number(reportData?.fyInrNetRevenue)?.toLocaleString('en-IN') : 0}</p>
                        </div>
                    </div>
                </div>
            
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-purple-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">FY - {reportData?.fyStartYear}/{reportData?.fyEndYear} Total USD Revenue</h3>
                            <p className="text-xl font-bold text-gray-900">${reportData && reportData.fyUsdRevenue ? Number(reportData?.fyUsdRevenue)?.toLocaleString('en-US') : 0}</p>
                            <p className="text-xs text-purple-600 mt-1">Net Revenue: ₹{reportData && reportData.fyUsdNetRevenue ? Number(reportData?.fyUsdNetRevenue)?.toLocaleString('en-IN') : 0}</p>
                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-indigo-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">FY - {reportData?.fyStartYear}/{reportData?.fyEndYear} Total Revenue</h3>
                            <p className="text-xl font-bold text-gray-900">₹{reportData && reportData.fyTotalRevenue ? Number(reportData?.fyTotalRevenue)?.toLocaleString('en-US') : 0}</p>
                            <p className="text-xs text-indigo-600 mt-1">Net Revenue: ₹{reportData && reportData.fyTotalNetRevenue ? Number(reportData?.fyTotalNetRevenue)?.toLocaleString('en-IN') : 0}</p>
                        </div>
                    </div>
                </div>
            </div>


            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-green-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">AS ON Active Subscribers</h3>
                            <p className="text-md font-bold text-gray-900">{reportData?.asonTotalActiveUser ? Number(reportData?.asonTotalActiveUser).toLocaleString('en-IN') : '0'}</p>
                            <p className="text-xs text-green-600 mt-1">Date: {reportData?.asonDate}</p>
                        </div>
                    </div>
                </div>
            
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-yellow-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">AS ON  Total Amount</h3>
                            <p className="text-md font-bold text-gray-900">₹{reportData && reportData.asonActiveTotalAmount ? Number(reportData?.asonActiveTotalAmount)?.toLocaleString('en-IN') : 0}</p>
                            {/* <p className="text-xs text-green-600 mt-1"></p> */}
                            <p className="text-xs text-yellow-600 mt-1">Date: {reportData?.asonDate}</p>
                        </div>
                    </div>
                </div>
            
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-purple-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">AS ON Total Consumed Amount</h3>
                            <p className="text-md font-bold text-gray-900">₹{reportData && reportData.asonActiveTotalConsumedAmount ? Number(reportData?.asonActiveTotalConsumedAmount)?.toLocaleString('en-US') : 0}</p>
                            <p className="text-xs text-purple-600 mt-1">Date: {reportData?.asonDate}</p>
                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-indigo-500">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-medium text-gray-500 mb-1">AS ON Total Balance Amount</h3>
                            <p className="text-md font-bold text-gray-900">₹{reportData && reportData.asonActiveTotalBalancedAmount ? Number(reportData?.asonActiveTotalBalancedAmount)?.toLocaleString('en-US') : 0}</p>
                            <p className="text-xs text-indigo-600 mt-1">Date: {reportData?.asonDate}</p>
                        </div>
                    </div>
                </div>
            </div>
          </>
        )}
        </>
    )
    
}

export default SubscriptionMetric;